/**
 * Converts a UTC timestamp string to a localized date-time string
 * formatted as "YYYY-MM-DD HH:mm" according to the user's timezone.
 * Returns '-' if the input is null or undefined.
 *
 * @param dateString - The UTC timestamp string (ISO format)
 * @returns Localized date-time string
 */
export const formatLocalDate = (dateString?: string | null): string => {
  if (!dateString) return '-'
  const d = new Date(dateString)
  if (isNaN(d.getTime())) return '-'

  const year = d.getFullYear()
  const month = String(d.getMonth() + 1).padStart(2, '0')
  const day = String(d.getDate()).padStart(2, '0')
  const hour = String(d.getHours()).padStart(2, '0') // 24-hour
  const minute = String(d.getMinutes()).padStart(2, '0')

  return `${year}-${month}-${day} ${hour}.${minute}`
}
